var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2651 10.5956C13.6807 10.5956 14.0505 10.4335 14.3747 10.1094C14.6988 9.78525 14.8609 9.41123 14.8609 8.98735C14.8609 8.56346 14.6988 8.1936 14.3747 7.87777C14.0505 7.56193 13.6807 7.40401 13.2651 7.40401C12.8495 7.40401 12.4797 7.56193 12.1555 7.87777C11.8314 8.1936 11.6693 8.56346 11.6693 8.98735C11.6693 9.41123 11.8314 9.78525 12.1555 10.1094C12.4797 10.4335 12.8495 10.5956 13.2651 10.5956ZM1.49606 15.1586V16.4801V1.5195V15.1586ZM1.49606 17.9762C1.11374 17.9762 0.76881 17.8266 0.461286 17.5274C0.153762 17.2282 0 16.8791 0 16.4801V1.5195C0 1.13717 0.153762 0.792248 0.461286 0.484724C0.76881 0.1772 1.11374 0.0234375 1.49606 0.0234375H16.4567C16.8556 0.0234375 17.2047 0.1772 17.5039 0.484724C17.8032 0.792248 17.9528 1.13717 17.9528 1.5195V4.86071H16.4567V1.5195H1.49606V16.4801H16.4567V13.1639H17.9528V16.4801C17.9528 16.8791 17.8032 17.2282 17.5039 17.5274C17.2047 17.8266 16.8556 17.9762 16.4567 17.9762H1.49606ZM10.4226 13.6625C9.85739 13.6625 9.40857 13.4963 9.07612 13.1639C8.74366 12.8314 8.57743 12.3909 8.57743 11.8423V6.18223C8.57743 5.61705 8.74366 5.17239 9.07612 4.84824C9.40857 4.52409 9.85739 4.36202 10.4226 4.36202H17.1549C17.72 4.36202 18.1689 4.52409 18.5013 4.84824C18.8338 5.17239 19 5.61705 19 6.18223V11.8423C19 12.3909 18.8338 12.8314 18.5013 13.1639C18.1689 13.4963 17.72 13.6625 17.1549 13.6625H10.4226ZM17.5039 12.1665V5.85808H10.0735V12.1665H17.5039Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarWallet);
export default __webpack_public_path__ + "static/media/navbarWallet.734b4ff18ca0dfe273e79b29d4a914e1.svg";
export { ForwardRef as ReactComponent };